import { ReactNode, ButtonHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { StyledButton } from './Button';
import { themed, ITheme } from '../../themer';

export interface IIconButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	inverted?: boolean;
	invertedSecondary?: boolean;
	secondary?: boolean;
	textButton?: boolean;
	iconPosition?: 'left' | 'right';
	children: ReactNode;
}

export const StyledIconButton = styled(StyledButton)<IIconButtonProps, ITheme>`
	display: inline-flex;
	align-items: center;
	gap: ${themed(({ button }) => button.iconSeparator)};

	svg {
		flex-grow: 0;
		flex-shrink: 0;
		height: ${themed(({ button }) => button.iconSize)};

		path {
			fill: currentColor;
		}
	}
`;
